import { produce } from 'immer';

import {
  getWebhooksDictionary,
  addCustomerCredits,
  updateCustomerCredits,
  cancelCustomerCredits,
} from '../actions/webhooks';

const initialState = {
  dictionary: {},
  loadings: {
    dictionary: false,
    addCustomerCredits: false,
    updateCustomerCredits: false,
    cancelCustomerCredits: false,
  },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET DICTIONARY
    case getWebhooksDictionary.types.START:
      state.loadings.dictionary = true;
      return state;

    case getWebhooksDictionary.types.SUCCESS:
      state.dictionary = action.payload.data;
      state.loadings.dictionary = false;
      return state;

    case getWebhooksDictionary.types.FAIL:
      state.loadings.dictionary = false;
      return state;

    // ELIGIBLE ADD
    case addCustomerCredits.types.START:
      state.loadings.addCustomerCredits = true;
      return state;

    case addCustomerCredits.types.SUCCESS:
    case addCustomerCredits.types.FAIL:
      state.loadings.addCustomerCredits = false;
      return state;

    // ELIGIBLE UPDATE
    case updateCustomerCredits.types.START:
      state.loadings.updateCustomerCredits = true;
      return state;

    case updateCustomerCredits.types.SUCCESS:
    case updateCustomerCredits.types.FAIL:
      state.loadings.updateCustomerCredits = false;
      return state;

    // ELIGIBLE CANCEL
    case cancelCustomerCredits.types.START:
      state.loadings.cancelCustomerCredits = true;
      return state;

    case cancelCustomerCredits.types.SUCCESS:
    case cancelCustomerCredits.types.FAIL:
      state.loadings.cancelCustomerCredits = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
